export const QUERY_KEYS = {
  // Agencies feature query keys
  AGENCIES: 'agencies',
  AGENCY_DETAILS: 'agencyDetails',

  // Currencies feature query keys
  CURRENCIES: 'currencies',
  CURRENCY: 'currency',

  // Inspectors feature query keys
  INSPECTOR_DETAILS: 'inspectorDetails',
  INSPECTORS: 'inspectors',
  INSPECTORS_FOR_JOB_SEARCH: 'inspectorsForJobSearch',
  INSPECTOR_CERTIFICATES: 'inspectorCertificates', // ⚠️ Used to fetch certificates list for inspector page filters and create/update forms
  INSPECTOR_SKILLS: 'inspectorSkills', // ⚠️ Used to fetch skills list for inspector page filters and create/update forms
  INSPECTOR_SKILLS_MASTER: 'inspectorSkillsMaster', // ⚠️ Used to fetch skills list for the skills management page
  INSPECTOR_CERTIFICATES_MASTER: 'inspectorCertificatesMaster', // ⚠️ Used to fetch certificates list for the certificates management page
  INSPECTOR_SKILL_BY_ID: 'inspectorSkillById',
  INSPECTOR_CERTIFICATE_BY_ID: 'inspectorCertificateById',
  INSPECTOR_EMAIL_DETAILS: 'inspectorEmailDetails',
  INSPECTOR_DOCUMENT_CATEGORIES: 'inspectorDocumentCategories',
  INSPECTOR_STATUS: 'inspectorStatus',

  // Locations feature query keys
  LOCATIONS: 'locations',
  CITIES_PAGINATED: 'citiesPaginated',

  // Clients feature query keys
  CLIENTS: 'clients',
  CLIENT_STATUSES: 'clientStatuses',
  CLIENT_AGREEMENT_CATEGORIES: 'clientAgreementCategories',
  CLIENT_AGREEMENT_STATUSES: 'clientAgreementStatuses',
  CLIENT_DETAILS: 'clientDetails',
  CLIENT_MASTER_DATA: 'clientMasterData',
  CLIENT_JOB_BREAKDOWN: 'clientJobBreakdown',
  CLIENT_POC_ATTRIBUTES: 'clientPocAttributes',
  CLIENT_POC_EXISTS: 'clientPocExists',

  // Framework Agreement feature query keys — one per slice, so each wizard step
  // caches (and fetches) only its own data.
  FRAMEWORK_AGREEMENT_CLIENT: 'frameworkAgreementClient',
  FRAMEWORK_AGREEMENT_OFFICE: 'frameworkAgreementOffice',
  FRAMEWORK_AGREEMENT_SPECS: 'frameworkAgreementSpecs',
  FRAMEWORK_AGREEMENT_COMMERCIALS: 'frameworkAgreementCommercials',
  FRAMEWORK_AGREEMENT_DOCUMENTS: 'frameworkAgreementDocuments',
  FRAMEWORK_AGREEMENT_NOTES: 'frameworkAgreementNotes',
  FRAMEWORK_AGREEMENT_INQUIRY_QUOTATION: 'frameworkAgreementInquiryQuotation',
  // Create-time prefill for a framework agreement sourced from a concluded inquiry + quotation.
  FRAMEWORK_AGREEMENT_DRAFT: 'frameworkAgreementDraft',
  // Combined read view — all slices above fetched in one request for the
  // single-page Framework Agreement details modal.
  FRAMEWORK_AGREEMENT_FULL: 'frameworkAgreementFull',
  FRAMEWORK_AGREEMENT_STATUSES: 'frameworkAgreementStatuses',
  FRAMEWORK_AGREEMENT_DOCUMENT_CATEGORIES:
    'frameworkAgreementDocumentCategories',
  FRAMEWORK_AGREEMENT_APPROVAL_STATE: 'frameworkAgreementApprovalState',
  FRAMEWORK_AGREEMENT_SUSPENSION_STATE: 'frameworkAgreementSuspensionState',
  FRAMEWORK_AGREEMENT_REVISION_STATE: 'frameworkAgreementRevisionState',
  FRAMEWORK_AGREEMENT_FILTERS: 'frameworkAgreementFilters',
  FRAMEWORK_AGREEMENTS_LIST: 'frameworkAgreementsList',
  // Deep-link resolve: agreement number → { id, clientId, canEdit }.
  RESOLVE_FRAMEWORK_AGREEMENT_IDENTIFIERS:
    'resolveFrameworkAgreementIdentifiers',
  // Which sections (commercials/documents) the current user may not access for an
  // agreement — drives the wizard's access-denied panels.
  FRAMEWORK_AGREEMENT_SECTION_ACCESS: 'frameworkAgreementSectionAccess',
  // Awarded inquiries linkable to an agreement (inquiry-quotation step search).
  FRAMEWORK_AGREEMENT_LINKABLE_INQUIRIES: 'frameworkAgreementLinkableInquiries',

  // Service Providers feature query keys
  SP_DEPARTMENTS: 'spDepartments',
  EMPLOYEE_DETAILS: 'employeeDetails',
  EMPLOYEES_BY_OFFICE: 'employeesByOffice',
  COORDINATORS_BY_OFFICE: 'coordinatorsByOffice',
  EMPLOYEES_BY_COMMERCIAL_ATTRIBUTES: 'employeesByCommercialAttributes',
  EMPLOYEES: 'employees',
  SERVICE_PROVIDER_EMPLOYEE: 'serviceProviderEmployee',
  SERVICE_PROVIDER_EMPLOYEES: 'serviceProviderEmployees',
  OFFICES: 'offices',
  COORDINATOR_DETAILS: 'coordinatorDetails',
  SP_HIERARCHIES: 'spHierarchies',
  SP_ROLES: 'spRoles',
  SP_OFFICES_RM_STATUS: 'spOfficesRMStatus',
  USER_MANAGEMENT_MASTER_DATA: 'userManagementMasterData',

  // Jobs feature query keys
  JOB_AGREEMENT_CATEGORIES: 'jobAgreementCategories',
  JOB_STATUSES: 'jobStatuses',
  JOB_DISCIPLINE: 'jobDiscipline',
  JOB_MATERIAL_CATEGORIES: 'jobMaterialCategories',
  JOBS_LIST: 'jobsList',
  JOB_DETAILS: 'jobDetails',
  JOB_ORDER_REPORTS: 'JOB_ORDER_REPORTS',
  JOB_REPORT_CATEGORIES: 'JOB_REPORT_CATEGORIES',
  JOB_REPORT_DETAILS: 'JOB_REPORT_DETAILS',
  JOB_VENDOR_MAPPING: 'jobVendorMapping',
  JOB_GROUPS_LIST: 'jobGroupsList',
  JOB_GROUP_BY_ID: 'jobGroupById',
  JOB_ORDERS_BY_JOB_GROUP: 'jobOrdersByJobGroup',

  // Vendors feature query keys
  VENDORS: 'vendors',
  VENDOR_DETAILS: 'vendorDetails',

  // Inquiries feature query keys
  INQUIRIES_FILTERS: 'inquiriesFilters',
  INQUIRIES_LIST: 'inquiriesList',
  INQUIRIES_SPECS: 'inquiriesSpecs',
  INQUIRIES_POCS: 'inquiriesPocs',
  INQUIRIES_DEPARTMENTS: 'inquiriesDepartments',
  INQUIRIES_DOCUMENTS: 'inquiriesDocuments',
  INQUIRIES_ALL_PARTS: 'inquiriesAllParts',
  INQUIRY_CLIENT_CHANGE_ELIGIBILITY: 'inquiryClientChangeEligibility',
  INQUIRY_ARCHIVE_ELIGIBILITY: 'inquiryArchiveEligibility',
  INQUIRY_ASSIGNABLE_STATUSES: 'inquiryAssignableStatuses',
  INQUIRY_REOPEN_EVENTS: 'inquiryReopenEvents',
  RESOLVE_INQUIRY_IDENTIFIERS: 'resolveInquiryIdentifiers',

  // Quotation Revisions feature query keys
  QUOTATION_REVISIONS: 'quotationRevisions',
  QUOTATION_REVISION_DETAILS: 'quotationRevisionDetails',
  RESOLVE_QUOTATION_IDENTIFIERS: 'resolveQuotationIdentifiers',
  QUOTATION_APPROVAL_STATUSES: 'quotationApprovalStatuses',
  QUOTATION_REVISION_APPROVAL_REQUIREMENTS:
    'quotationRevisionApprovalRequirements',

  // QMS / certificate standards
  QMS_CERTIFICATE_STANDARDS_LIST: 'qmsCertificateStandardsList',
  QMS_CERTIFICATE_STANDARD: 'qmsCertificateStandard',
  QMS_CERTIFICATES_LIST: 'qmsCertificatesList',
  QMS_CERTIFICATE_MODAL_DETAIL: 'qmsCertificateModalDetail',
  QMS_CERTIFICATE_CYCLE_DOCUMENTS: 'qmsCertificateCycleDocuments',
  QMS_CERTIFICATE: 'qmsCertificate',
  QMS_CERTIFICATE_MAPPED_STANDARDS: 'qmsCertificateMappedStandards',
  QMS_CERTIFICATE_LOCATIONS: 'qmsCertificateLocations',
};

// ⚠️ IMPORTANT: These are the base values for the features (used by hooks and queries) and should not be changed unless absolutely necessary
// ⚠️ Before any change, a thorough review of the feature and its usage should be done to ensure that the change is not breaking any existing functionality.
export const CLIENT_APPROVED = 'CLIENT_APPROVED';
export const BASE_DEPT = 'TPI_WWI';
export const BASE_INSPECTOR_CODE = 'Inspector';
export const BASE_AGREEMENT_STATUS = 'AGREEMENT_APPROVED';
export const BASE_CLIENT_STATUS = 'CLIENT_APPROVED';
export const BASE_JOB_STATUS = 'JOB_NEW';
